interface InputLabelTitleProps {
  title: string;
  required?: boolean;
  hasError?: boolean;
}

export const InputLabelTitle = ({
  title,
  required = false,
  hasError = false,
}: InputLabelTitleProps) => (
  <span className={`font-bold ${hasError ? 'text-[#ED4136]' : ''}`}>
    {title}
    {required && <span className="text-[#ED4136]">*</span>}
  </span>
);
